import { ISortedContentBlock } from '@core/services/interfaces';
import { IFindMeetingReviewFilter, IOrder, ReviewListItem } from 'lingo2-models';

export enum StampEnum {
  recommended,
  new,
  top,
}

export interface IStatsList {
  name: string;
  icon: string;
  color: string;
  title: string;
  value: number;
  reviews_count?: number;
}

export type TeacherCardTabType = 'teaching' | 'about' | 'services' | 'schedule' | 'reviews';
export type ReviewsBlockType = ISortedContentBlock<ReviewListItem, IFindMeetingReviewFilter, IOrder<ReviewListItem>>;

export interface ITeacherCardComponentState {
  isMediaPrepared: boolean;
  open: boolean;
  tabsExpand: boolean;
  openMobileModal: boolean;
  closeModal: boolean;
  opened_popup: boolean;
  activeServiceIndex: number;
  complainForm: boolean;
  subscribed: boolean;
}
